import http from './httpService';

// eslint-disable-next-line no-undef
const applicationEndpoint = `${API}/api/Application`;
export function getCV(url) {
  return http.get(applicationEndpoint + '/getCV', {
    responseType: 'blob',
    params: { url: url },
  });
}

export function addOrUpdateCommentToApplication(commentDto) {
  return http.put(applicationEndpoint + '/addOrUpdateCommentToApplication', {
    Id: commentDto.commentId,
    Title: commentDto.commentTitle,
    Message: commentDto.commentMessage,
    ApplicationId: commentDto.applicationId,
    Rating: commentDto.rating,
  });
}

export function updateApplicationStatus(
  applicationId,
  newStatusId,
  newStatusName,
  oldStatusId,
  oldStatusName,
  sendAutomatedEmail,
  emailSubject,
  emailContent,
  mappedArray,
  jobId,
  jobTitle,
  applicantFullName
) {
  // eslint-disable-next-line no-undef
  const webPortalEndpoint = `${JOB_PORTAL_URL}/applications?jobId=`;

  return http.put(applicationEndpoint + '/updateApplicationStatus', {
    ApplicationId: applicationId,
    NewStatusId: newStatusId,
    NewStatusName: newStatusName,
    OldStatusId: oldStatusId,
    OldStatusName: oldStatusName,
    SendAutomatedEmail: sendAutomatedEmail,
    EmailSubject: emailSubject,
    EmailContent: emailContent,
    ApplicationIndexList: mappedArray,
    JobId: jobId,
    Url: webPortalEndpoint + jobId,
    JobTitle: jobTitle,
    ApplicantFullName: applicantFullName,
  });
}

export function updateKanbanColumnOrder(applicationsToUpdate) {
  return http.put(applicationEndpoint + '/updateKanbanColumnOrder', applicationsToUpdate);
}

export function sendAutomatedEmail(
  applicationId,
  newStatusId,
  newStatusName,
  oldStatusId,
  oldStatusName,
  sendAutomatedEmail,
  emailSubject,
  emailContent
) {
  return http.put(applicationEndpoint + '/sendAutomatedEmail', {
    ApplicationId: applicationId,
    NewStatusId: newStatusId,
    NewStatusName: newStatusName,
    OldStatusId: oldStatusId,
    OldStatusName: oldStatusName,
    SendAutomatedEmail: sendAutomatedEmail,
    EmailSubject: emailSubject,
    EmailContent: emailContent,
  });
}

export function sendTestEmailForKanbanConfiguration(emailSubject, emailContent) {
  return http.put(applicationEndpoint + '/sendTestEmailForKanbanConfiguration', {
    EmailSubject: emailSubject,
    EmailContent: emailContent,
  });
}

export function sendTestEmail(emailAddress, emailSubject, emailContent) {
  return http.put(applicationEndpoint + '/sendTestEmail', {
    EmailAddress: emailAddress,
    EmailSubject: emailSubject,
    EmailContent: emailContent,
  });
}

export function updateQuestionnaire(questionnaire) {
  return http.put(applicationEndpoint + '/updateQuestionnaire', questionnaire);
}

export function assignUserToTheApplication(applicationId, userId) {
  return http.put(applicationEndpoint + '/assignUserToTheApplication', {
    applicationId,
    userId,
  });
}

export function getApplications(ApplicationParams) {
  return http.get(applicationEndpoint + '/getApplications', {
    params: {
      JobTitle: ApplicationParams.JobTitle,
      JobType: ApplicationParams.JobType.value,
      ApplicantName: ApplicationParams.FirstName,
      ApplicantSecondName: ApplicationParams.LastName,
      ApplicationType: ApplicationParams.ApplicationType?.value,
      PageNumber: ApplicationParams.PageNumber,
      PageSize: ApplicationParams.PageSize,
      JobId: ApplicationParams.JobId,
      ApplicationStatus: ApplicationParams.ApplicationStatus?.value,
      OnlyNew: ApplicationParams.OnlyNew,
      SortByScore: ApplicationParams.SortByScore,
      MineOrAllSelected: ApplicationParams.MineOrAllSelected,
      Lat: ApplicationParams.Lat,
      Lng: ApplicationParams.Lng,
      Distance: ApplicationParams.DistanceFromCity?.value,
    },
  });
}

export function getApplication(id) {
  return http.get(applicationEndpoint + '/getApplication', {
    params: {
      applicationId: id,
    },
  });
}

export function getApplicationBYJobAndApplicant(jobId, applicantId) {
  return http.get(applicationEndpoint + '/getApplicationFromJobAndApplicant', {
    params: {
      jobId: jobId,
      applicantId: applicantId,
    },
  });
}

export function getQuestionsForQuestionnaireWithAnswers(jobId, applicationId) {
  return http.get(applicationEndpoint + '/getQuestionsForQuestionnaireWithAnswers', {
    params: {
      jobId: jobId,
      applicationId: applicationId,
    },
  });
}

// With given applicationId or applicantId you inform the BE from where it needs to be deleted.
export function deleteCv(cvUrl, applicantId, applicationId) {
  return http.delete(applicationEndpoint + '/deleteCV', {
    params: {
      url: cvUrl,
      applicantId: applicantId,
      applicationId: applicationId,
    },
  });
}

export function updateCV(cvFile, applicantId, applicationId) {
  const fileData = new FormData();
  fileData.append('cvFile', cvFile);
  fileData.append('applicantId', applicantId);
  fileData.append('applicationId', applicationId);

  return http.post(applicationEndpoint + '/updateCV', fileData);
}
